<template>
<div>
</div>
</template>

<script>
import { useClient, useMutation } from 'villus';
import { gql } from 'graphql-tag';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'updatePointsMutation',

  setup() {
    const store = useStore();

    useClient({
      url: process.env.VUE_APP_STRAPI,
    });

    const updatePointsMutation = gql`
      mutation($id: ID!, $points: JSON!) {
        updateUserData(id: $id, data: { points: $points }) {
          data {
            id
          }
        }
      }
      `;

    const context = reactive({
      headers: computed(() => store.state.auth.headers),
    });

    const { execute: updatePoints } = useMutation(updatePointsMutation, {
      context,
    });

    store.commit('setStrapiExecutionHandler', { item: 'updatePoints', result: updatePoints });
  },
};
</script>
